const initialState = {
  cache: {},
  list: [],
  listTotal: 0,
  listVersion: 0,
  listState: 'idle',
  statusTypes: [],
};

function subscribersReducer(state = initialState, action) {
  // console.log(action);
  switch (action.type) {
    case 'subscribers/statusTypes': {
      return {
        ...state,
        statusTypes: action.data,
      };
    }
    case 'subscribers/list': {
      return {
        ...state,
        list: action.data.content,
        listTotal: action.data.pageable.totalElements,
        listState: 'success'
      };
    }
    case 'subscribers/refresh': {
      return {
        ...state,
        listVersion: state.listVersion + 1,
        listState: 'refresh',
      };
    }
    case 'subscribers/cache': {
      return {
        ...state,
        cache: { ...state.cache, [action.data.id]: action.data },
      };
    }
    case 'subscribers/listState': {
      return {
        ...state,
        listState: 'refresh',
      };
    }
    default:
      return state;
  }
}

export default subscribersReducer;
